import { render, staticRenderFns } from "./PuzzleSolution.vue?vue&type=template&id=70c8fd56"
import script from "./PuzzleSolution.vue?vue&type=script&lang=js"
export * from "./PuzzleSolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports